import { render } from "./TextPopover.vue?vue&type=template&id=79f96a48&lang=pug"
import script from "./TextPopover.vue?vue&type=script&lang=js"
export * from "./TextPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__